import React from 'react';
import { Helmet } from 'react-helmet';

const HubSpotChat: React.FC = () => {
  // Simply render the HubSpot script tag directly
  // This is the most reliable way to ensure the chat widget appears
  return (
    <Helmet>
      {/* Start of HubSpot Embed Code */}
      <script type="text/javascript" id="hs-script-loader" async defer src="//js-na2.hs-scripts.com/242769171.js"></script>
      {/* End of HubSpot Embed Code */}
    </Helmet>
  );
};

export default HubSpotChat; 